import { CSSProperties, useEffect, useRef, useState } from 'react';
import './index.less';

export const AIIcon = (props: { size?: number|string; style?: CSSProperties; className?: string; onClick?: () => void; }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const size = props.size || 28;
  // const scale = size / 28;
  useEffect(()=>{
    if (ref.current){
      const rect = ref.current.getBoundingClientRect();
      const childrect = ref.current.children[0].getBoundingClientRect();
      const scaleX = rect.width / childrect.width;
      const scaleY = rect.height / childrect.height;
      setScale(Math.min(scaleX, scaleY));
    }
  },[size]);
  return <div className={props.className} ref={ref} style={{ ...props.style, width: size, height: size }} onClick={props?.onClick && props.onClick}>
    <div className='ai-robot' style={{ transform: `scale(${scale})` }}>
      <div className='ai-robot-head'>
        <div className='ai-robot-face'>
          <div className='ai-robot-eye eye1'></div>
          <div className='ai-robot-eye eye2'></div>
        </div>
      </div>
    </div>
  </div>;
};